import React, { ReactNode } from 'react';
import { Alert } from '@ver-uds/uswds-react';
import { columns } from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUsersTableData';
import BaseEVerifyUsers from './BaseEVerifyUsers';
import AlertConstants from '../../../../constants/AlertConstants';
import EVerifyUser from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUser';

const CorporateAdminEverifyUsers = (): JSX.Element => {
  const primaryText: ReactNode = (
    <>
      <div className="tablet:grid-col-12 desktop:grid-col-9">
        <p className="usa-intro">A company must designate one Corporate Administrator.</p>
        <ul>
          <li>
            Corporate Administrators have the ability to create company locations, create user accounts, perform
            queries, view reports, update account information, and unlock user accounts.
          </li>
          <li>Corporate Administrators CANNOT create, edit, or view E-Verify cases.</li>
          <li>Sharing accounts is not permitted; all users must have their own individual user accounts.</li>
        </ul>
      </div>
      <Alert className="tablet:grid-col-12 desktop:grid-col-9 margin-bottom-4" status="info" slim>
        <Alert.Text>{AlertConstants.EVERIFY_USERS_CORPORATE_ADMIN_INFO}</Alert.Text>
      </Alert>
    </>
  );

  const secondaryText =
    'The person entered here will become the Corporate Administrator and the Point of Contact for this E-Verify account. Additional Corporate Administrators can be added or deleted after enrollment is complete.';

  const corpAdminColumns = columns.filter(({ accessor }) => !['mouSignatory', 'admin'].includes(accessor as string));

  const isAddDisabled = (users: EVerifyUser[]) => users.length === 1;

  const checkUsersForError = (users: EVerifyUser[]): AlertConstants | undefined => {
    if (users?.length === 0) {
      return AlertConstants.EVERIFY_USERS_NO_CORP_ADMIN;
    }
    return undefined;
  };

  return (
    <BaseEVerifyUsers
      addButtonText="Add Administrator"
      noRowsText="No Corporate Administrators Added"
      primaryText={primaryText}
      secondaryText={secondaryText}
      columns={corpAdminColumns}
      isAddDisabled={isAddDisabled}
      checkUsersForError={checkUsersForError}
    />
  );
};

export default CorporateAdminEverifyUsers;
